import { createAsyncTypes } from 'utils/ActionCreator'

import { INCIDENT_TYPE } from '../constants'

const CLASSIFICATION_SPAM_COLOR = 'var(--classification-spam)'
const CLASSIFICATION_PHISHING_COLOR = 'var(--classification-phishing)'
const CLASSIFICATION_SAFE_COLOR = 'var(--classification-safe)'

export const REPORT_REQUEST_ASYNC = createAsyncTypes(
  'REPORT_REQUEST_ASYNC',
  'ResolutionCenter/Report'
)
export const REPORT_STATE_CHANGE_ASYNC = createAsyncTypes(
  'REPORT_STATE_CHANGE_ASYNC',
  'ResolutionCenter/Report'
)
export const FETCH_COMMUNITY_INSIGHTS_ASYNC = createAsyncTypes(
  'FETCH_COMMUNITY_INSIGHTS_ASYNC',
  'ResolutionCenter/Report'
)
export const REPORT_ELEMENTS_UPDATE_ASYNC = createAsyncTypes(
  'REPORT_ELEMENTS_UPDATE_ASYNC',
  'ResolutionCenter/Report'
)
export const REPORT_ELEMENTS_REQUEST_ASYNC = createAsyncTypes(
  'REPORT_ELEMENTS_REQUEST_ASYNC',
  'ResolutionCenter/Report'
)
export const FETCH_REPORT_ELEMENTS_ASYNC = createAsyncTypes(
  'FETCH_REPORT_ELEMENTS_ASYNC',
  'ResolutionCenter/Report'
)
export const FETCH_PAGINATED_REPORTERS_ASYNC = createAsyncTypes(
  'FETCH_PAGINATED_REPORTERS_ASYNC',
  'ResolutionCenter/Report'
)
export const VALIDATE_NEW_AFFECTED_MAILBOXES_SEEN_ASYNC = createAsyncTypes(
  'VALIDATE_NEW_AFFECTED_MAILBOXES_SEEN_ASYNC',
  'ResolutionCenter/Report'
)
export const FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC = createAsyncTypes(
  'FETCH_AFFECTED_MAILBOXES_COUNTS_ASYNC',
  'ResolutionCenter/Report'
)
export const FETCH_SCANS_FREEMIUM_LIMIT_ASYNC = createAsyncTypes(
  'FETCH_SCANS_FREEMIUM_LIMIT',
  'ResolutionCenter/Report'
)
export const DOWNLOAD_ORIGINAL_EMAIL_ASYNC = createAsyncTypes(
  'DOWNLOAD_ORIGINAL_EMAIL',
  'ResolutionCenter/Report'
)

export const FETCH_ASSIGNEES_ASYNC = createAsyncTypes('FETCH_ASSIGNEES', 'ResolutionCenter/Report')

export const CHANGE_ASSIGNEES_ASYNC = createAsyncTypes(
  'CHANGE_ASSIGNEES',
  'ResolutionCenter/Report'
)

export const EMAIL_SNAPSHOT_ASYNC = createAsyncTypes('EMAIL_SNAPSHOT', 'ResolutionCenter/Report')

export const THEMIS_ANALYSIS_ASYNC = createAsyncTypes('THEMIS_ANALYSIS', 'ResolutionCenter/Report')
export const THEMIS_ANALYSIS_PARTIAL_UPDATE =
  'ResolutionCenter/Report/THEMIS_ANALYSIS_PARTIAL_UPDATE'
export const THEMIS_MAX_RETRIES = 3

// Explicit "user asked to generate" intent for the Phishing SOC deep investigation.
// Gates the auto-start effects so a credit is spent only on a current user action
// (not on a credit-balance change / remount / refresh). The intent is consumed in
// the reducer at THEMIS_ANALYSIS_ASYNC.INITIATE (the spend event). See IC-49715.
export const REQUEST_THEMIS_GENERATE_ASYNC = createAsyncTypes(
  'REQUEST_THEMIS_GENERATE',
  'ResolutionCenter/Report'
)

export const OPEN_EMAIL_SNAPSHOT_NEW_TAB = 'ResolutionCenter/Report/OPEN_EMAIL_SNAPSHOT_NEW_TAB'

export const SHOW_SCANNER_DETAILS_VIEW = 'ResolutionCenter/Report/SHOW_SCANNER_DETAILS_VIEW'
export const SHOW_AFFECTED_MAILBOXES_VIEW = 'ResolutionCenter/Report/SHOW_AFFECTED_MAILBOXES_VIEW'

export const CLOSE_INCIDENT_ASYNC = createAsyncTypes('CLOSE_INCIDENT', 'ResolutionCenter/Report')

export const CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC = createAsyncTypes(
  'CLOSE_SAFE_CHALLENGE_INCIDENT',
  'ResolutionCenter/Report'
)

export const RELEASE_ENCRYPTED_INCIDENT_ASYNC = createAsyncTypes(
  'RELEASE_ENCRYPTED_INCIDENT',
  'ResolutionCenter/Report'
)

export const KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE_ASYNC = createAsyncTypes(
  'KEEP_ENCRYPTED_INCIDENT_IN_QUARANTINE',
  'ResolutionCenter/Report'
)

export const FETCH_MSFT_QUARANTINE_REPORT_ASYNC = createAsyncTypes(
  'FETCH_MSFT_QUARANTINE_REPORT',
  'ResolutionCenter/Report'
)

export const RELEASE_MSFT_QUARANTINE_REPORT_ASYNC = createAsyncTypes(
  'RELEASE_MSFT_QUARANTINE_REPORT',
  'ResolutionCenter/Report'
)

export const UPDATE_MSFT_QUARANTINE_ASSIGNEE_ASYNC = createAsyncTypes(
  'UPDATE_MSFT_QUARANTINE_ASSIGNEE',
  'ResolutionCenter/Report'
)

export const SET_ESCALATED_EMAIL_CARD_TAB_KEY =
  'ResolutionCenter/Report/SET_ESCALATED_EMAIL_CARD_TAB_KEY'

// Microsoft Quarantine Actions
export const MSFT_QUARANTINE_ACTIONS = {
  RELEASE: 1,
  CLOSE: 2,
}

export const REPORT_STATE = {
  MAIL: {
    REPORT: 1,
    FALSE_POSITIVE: 2,
    APPROVED_MANUALLY: 3,
    ABOVE_THRESHOLD: 4,
    FEDERATED_ATTACK: 5,
    MALICIOUS_CONTENT: 6,
    MARKED_AS_SPAM: 7,
    FEDERATED_REPORT: 8,
    AUTO_SPAM: 10,
    AUTO_APPROVED: 11,
    AUTO_JUNK_FOLDER_CLASSIFICATION_SPAM: 16,
    AUTO_SAFE: 20,
  },
  TEAMS: {
    PHISHING: 1,
    SAFE: 2,
  },
  MSFT: {
    PHISHING: 1,
    SAFE: 4,
    SPAM: 2,
  },
}

export const ACTION_STATE_CHANGE_TO_STATE = {
  [INCIDENT_TYPE.MAIL]: {
    malicious: REPORT_STATE.MAIL.APPROVED_MANUALLY,
    fp: REPORT_STATE.MAIL.FALSE_POSITIVE,
    spam: REPORT_STATE.MAIL.MARKED_AS_SPAM,
  },
  [INCIDENT_TYPE.TEAMS]: {
    malicious: REPORT_STATE.TEAMS.PHISHING,
    fp: REPORT_STATE.TEAMS.SAFE,
  },
}

export const ATTACK_STATES = {
  [INCIDENT_TYPE.MAIL]: [
    REPORT_STATE.MAIL.APPROVED_MANUALLY,
    REPORT_STATE.MAIL.MALICIOUS_CONTENT,
    REPORT_STATE.MAIL.AUTO_APPROVED,
  ],
  [INCIDENT_TYPE.TEAMS]: [REPORT_STATE.TEAMS.PHISHING],
}

export const UNCLASSIFIED_STATES = [
  REPORT_STATE.MAIL.REPORT,
  REPORT_STATE.MAIL.ABOVE_THRESHOLD,
  REPORT_STATE.MAIL.FEDERATED_ATTACK,
  REPORT_STATE.MAIL.FEDERATED_REPORT,
]

export const statusesMap = ['N/A', 'Malicious', 'No IOC', 'Scanning...', 'Scan Failed']
export const MAX_POLLING_ATTEMPTS = 4

export const statusKeyMap = {
  na: 0,
  malicious: 1,
  clean: 2,
  scanning: 3,
  error: 4,
}

export const orderOfStatus = {
  'N/A': 3,
  Malicious: 1,
  'Mixed results': 2,
  'No IOC': 3,
  'Scanning...': 3,
  'Scan Failed': 3,
}

export const orderOfReputation = {
  High: 0.2,
  Medium: 0.4,
  Low: 0.6,
}

export const CLASSIFICATION_STATE = {
  [INCIDENT_TYPE.MAIL]: {
    spam: {
      text: 'Spam',
      actionTextInfoKey: 'spam',
      states: [
        REPORT_STATE.MAIL.MARKED_AS_SPAM,
        REPORT_STATE.MAIL.AUTO_SPAM,
        REPORT_STATE.MAIL.AUTO_JUNK_FOLDER_CLASSIFICATION_SPAM,
      ],
      iconName: 'spam',
      iconColor: CLASSIFICATION_SPAM_COLOR,
      activeBgColor: CLASSIFICATION_SPAM_COLOR,
    },
    malicious: {
      text: 'Phishing',
      actionTextInfoKey: 'phishing',
      states: ATTACK_STATES[INCIDENT_TYPE.MAIL],
      iconName: 'phishing',
      iconColor: CLASSIFICATION_PHISHING_COLOR,
      activeBgColor: CLASSIFICATION_PHISHING_COLOR,
    },
    fp: {
      text: 'Safe',
      actionTextInfoKey: 'safe',
      states: [REPORT_STATE.MAIL.FALSE_POSITIVE, REPORT_STATE.MAIL.AUTO_SAFE],
      iconName: 'check-circle',
      iconColor: CLASSIFICATION_SAFE_COLOR,
      activeBgColor: CLASSIFICATION_SAFE_COLOR,
    },
  },
  [INCIDENT_TYPE.TEAMS]: {
    malicious: {
      text: 'Phishing',
      actionTextInfoKey: 'phishing',
      states: [REPORT_STATE.TEAMS.PHISHING],
      iconName: 'phishing',
      iconColor: CLASSIFICATION_PHISHING_COLOR,
      activeBgColor: CLASSIFICATION_PHISHING_COLOR,
    },
    fp: {
      text: 'Safe',
      actionTextInfoKey: 'safe',
      states: [REPORT_STATE.TEAMS.SAFE],
      iconName: 'check-circle',
      iconColor: CLASSIFICATION_SAFE_COLOR,
      activeBgColor: CLASSIFICATION_SAFE_COLOR,
    },
  },
  [INCIDENT_TYPE.POTENTIAL_MAIL]: {
    malicious: {
      text: 'Phishing',
      actionTextInfoKey: 'phishing',
      states: [],
      iconName: 'phishing',
      iconColor: CLASSIFICATION_PHISHING_COLOR,
      activeBgColor: CLASSIFICATION_PHISHING_COLOR,
    },
  },
  [INCIDENT_TYPE.AUTO_THEMIS_POTENTIAL_MAIL]: {
    malicious: {
      text: 'Phishing',
      actionTextInfoKey: 'phishing',
      states: [],
      iconName: 'phishing',
      iconColor: CLASSIFICATION_PHISHING_COLOR,
      activeBgColor: CLASSIFICATION_PHISHING_COLOR,
    },
  },
  [INCIDENT_TYPE.MSFT]: {
    malicious: {
      text: 'Phishing',
      actionTextInfoKey: 'phishing',
      states: [REPORT_STATE.MSFT.PHISHING],
      iconName: 'phishing',
      iconColor: CLASSIFICATION_PHISHING_COLOR,
      activeBgColor: CLASSIFICATION_PHISHING_COLOR,
    },
    spam: {
      text: 'Spam',
      actionTextInfoKey: 'spam',
      states: [REPORT_STATE.MSFT.SPAM],
      iconName: 'spam',
      iconColor: CLASSIFICATION_SPAM_COLOR,
      activeBgColor: CLASSIFICATION_SPAM_COLOR,
    },
    fp: {
      text: 'Safe',
      actionTextInfoKey: 'safe',
      states: [REPORT_STATE.MSFT.SAFE],
      iconName: 'check-circle',
      iconColor: CLASSIFICATION_SAFE_COLOR,
      activeBgColor: CLASSIFICATION_SAFE_COLOR,
    },
  },
}

export const CLASSIFICATION_ACTION_TEXTS = {
  1: { action: 'Move to quarantine', sentence: 'moved to quarantine' },
  2: {
    action: 'Flag with inline message',
    sentence: 'flagged with inline message',
  },
  3: { action: 'Move to spam folder', sentence: 'moved to spam folder' },
  4: { action: 'Revert to mailbox', sentence: 'affected' },
  5: {
    action: 'Remove inline message',
    sentence: 'inline message removed',
    differentSentencing: true,
  },
  6: { action: 'Revert to mailbox', sentence: 'reverted to mailbox' },
  8: { action: 'Keep in quarantine', sentence: 'kept in quarantine' },
  9: {
    action: 'Keep flagged with inline message',
    sentence: 'kept flagged with inline message',
  },
  10: { action: 'Keep in spam', sentence: 'kept in spam' },
}

export const REVERT_TO_MAILBOX_CONST = 4

export const EMAIL_TABS_KEYS = {
  EMAIL_BODY: 0,
  HEADERS: 1,
  LINKS: 2,
  ATTACHMENTS: 3,
  SNAPSHOT: 4,
}

export const SCROLL_TO_TOP_SECTION_ID = 'scroll_to_top'
export const SENDER_ANALYSIS_SECTION_ID = 'rc-sender-analysis-section'
export const OVERVIEW_SECTION_ID = 'overview-section'
export const EMAILS_SECTION_ID = 'rc-escalated-email-section'
export const COMMUNITY_SECTION_ID = 'rc-community-section'

export const HEADER_SECTIONS_SCROLL = {
  [INCIDENT_TYPE.MAIL]: {
    sections: [
      {
        title: 'Phishing SOC Agent',
        id: SCROLL_TO_TOP_SECTION_ID,
        disabled: (
          ff,
          themisSummary,
          fromScanBack,
          isTrialEnded,
          isCompleteProtect,
          isStaticSalesDemo,
          permissions
        ) =>
          fromScanBack ||
          isStaticSalesDemo ||
          (!(ff?.ENABLE_THEMIS_AI_ANALYSIS && ff?.phishSoc) &&
            !ff?.ENABLE_THEMIS_AI_TRIAL_CAMPAIGN &&
            !ff?.POV_COSTUMER_FF) ||
          !themisSummary ||
          (ff?.ENABLE_THEMIS_AI_TRIAL_CAMPAIGN && isTrialEnded && !isCompleteProtect) ||
          !(permissions?.phishingSocAccess || permissions?.phishing_soc_access),
      },
      {
        title: (themisSummary) => (themisSummary ? 'Themis insight' : 'Overview'),
        id: OVERVIEW_SECTION_ID,
      },
      { title: 'Emails', id: EMAILS_SECTION_ID, withCounter: 'mitigationsCount' },
      { title: 'Sender analysis', id: SENDER_ANALYSIS_SECTION_ID },
      { title: 'Community', id: COMMUNITY_SECTION_ID },
    ],
    items: [
      SCROLL_TO_TOP_SECTION_ID,
      OVERVIEW_SECTION_ID,
      EMAILS_SECTION_ID,
      SENDER_ANALYSIS_SECTION_ID,
      COMMUNITY_SECTION_ID,
    ],
  },
  [INCIDENT_TYPE.TEAMS]: {
    sections: [
      { title: 'Overview', id: 'scroll_to_top' },
      { title: 'Links', id: 'rc_links_count', withCounter: 'links' },
      {
        title: 'Attachments',
        id: 'rc_files_count',
        withCounter: 'attachments',
      },
      { title: 'Members', id: 'rc_mst_members', withCounter: 'members' },
    ],
    items: ['scroll_to_top', 'links', 'attachments', 'members'],
  },
  [INCIDENT_TYPE.MSFT]: {
    sections: [{ title: '', id: 'scroll_to_top' }],
    items: ['scroll_to_top'],
  },
}

export const TEAMS_SOURCE = {
  CHAT: 1,
  CHANNEL: 2,
}

export const MAP_TEAMS_SOURCE_TO_LABEL = {
  [TEAMS_SOURCE.CHAT]: 'Group Chat',
  [TEAMS_SOURCE.CHANNEL]: 'Channel',
}

export const UNIFIED_REPORT_STATE = {
  PHISHING: 1,
  SPAM: 2,
  COMPROMISED: 3,
  SAFE: 4,
  OPEN: 5,
  SILENT: 6,
}

export const CLASSIFICATION_INFO_TEXTS = {
  Phishing:
    'Phishing is a malicious attack where fraudsters pose as a legit business or organization to gain sensitive info. ' +
    'IRONSCALES takes action on emails classified as Phishing based on the defined Incident Response.',
  Spam:
    'Spam is an unsolicited bulk email, typically sent for commercial purposes. IRONSCALES responds to such incidents ' +
    'by automatically executing the action defined in the Incident Response settings page.',
  Safe: 'The incident has been deemed safe, and all emails have been left in their respective mailboxes.',
}

export const EMAIL_CONTENT_TYPE = {
  FILES: 1,
  LINKS: 2,
}
